import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

// APIの住所を設定します。
const customerIdServices = (): any => {
  return {
    getCustomerId: () => apiClient.get(`${API_BASE_ADDRESS}/mypage/customer-id`),
  };
};

export default customerIdServices;
